import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import {getLocationGroupFromLocation, getPlanLocationFromLocation} from './location_helpers'

const styles = theme => ({
  root: {
    display: 'flex',
  },
  formControl: {
    margin: theme.spacing.unit * 3,
  },
  group: {
    margin: `${theme.spacing.unit}px 0`,
  },
});

class AssignmentForm extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
  };

  handleChangeLocation(event) {
    
    this.props.actions.changeAssignment(this.props.schedule, 
      this.props.plans, 
      this.props.workerAssignmentForm.worker,
      this.props.workerAssignmentForm.date,
      event.target.value,
      undefined,
      undefined);
  }
  handleChangeRole( event)
  {
    let roles = event.target.value.split('+');
    //console.log({roles});
    this.props.actions.changeAssignment(this.props.schedule, 
      this.props.plans, 
      this.props.workerAssignmentForm.worker,
      this.props.workerAssignmentForm.date,
      undefined,
      roles,
      undefined);
  }

  handleChangeLocked(event)
  {
    this.props.actions.changeAssignment(this.props.schedule, 
      this.props.plans, 
      this.props.workerAssignmentForm.worker,
      this.props.workerAssignmentForm.date,
      undefined,
      undefined,
      event.target.checked);
  }

  render() {
    if (!this.props.allLocations || !this.props.workerAssignmentForm || (!this.props.workerAssignmentForm.open))
    {
      //console.log("!allLoc: " + !this.props.allLocations);
      //console.log("!open: " + !this.props.workerAssignmentForm || (!this.props.workerAssignmentForm.open));
      return null;
    }
    
    const { classes } = this.props;
    let matchingAssignments = this.props.schedule.scheduleAssignments.filter(sa => (sa.workerId === this.props.workerAssignmentForm.worker.id && (sa.date === this.props.workerAssignmentForm.date)));
    //console.log({matchingAssignments, waf: this.props.workerAssignmentForm});
    if (!matchingAssignments || (matchingAssignments.length!==1))
    {
//      console.log({r:"no assignment", workerId: this.props.workerAssignmentForm.worker.id, date: this.props.workerAssignmentForm.date, count: matchingAssignments.length});
      return "no assignment found" 
    }
      
    let assignment = matchingAssignments[0];
    
    //console.log({assignment});
        
    return (
      <div className="home-assignment-form">
        <Dialog
    open={this.props.workerAssignmentForm && this.props.workerAssignmentForm.open}
    onClose={() => this.props.actions.setAssignmentFormOpen(null, null, null, false)}
    aria-labelledby="form-dialog-title"
  >
    <DialogContent>
    <FormControl component="fieldset" className={classes.formControl}>
    <FormLabel component="legend">Standort</FormLabel>
    
    <RadioGroup
          aria-label="location"
          name="location"
          className={this.props.classes.group}
          value={assignment.location}
          onChange={this.handleChangeLocation.bind(this)}
        >
        <FormControlLabel value={""} control={<Radio />} label={"nicht eingeteilt"} />
    {Object.values(this.props.allLocations).map(l => l.name)
    .filter(loc => this.props.workerAssignmentForm.worker_locations.some(workerLocGroup => workerLocGroup == getLocationGroupFromLocation(loc)))
    .filter(loc => Object.values(this.props.plans).filter(p => p.date === this.props.workerAssignmentForm.date).some(p => p.location === getPlanLocationFromLocation(loc)))
    .map(loc => 
    <FormControlLabel key={loc} value={loc} control={<Radio />} label={loc} />
    )
    }
    </RadioGroup>

    <FormControlLabel
        control={
          <Checkbox checked={assignment.locked} onChange={this.handleChangeLocked.bind(this)} value="locked" />
        }
        label="Festlegen"
      />
    </FormControl>
    <FormControl component="fieldset" className={classes.formControl}>
        <FormLabel component="legend">Position</FormLabel>

        <RadioGroup
          aria-label="position"
          name="position"
          className={this.props.classes.group}
          value={assignment.roles.join("+")}
          onChange={this.handleChangeRole.bind(this)}
        >
       
       {this.props.workerAssignmentForm.roleCombinations.map(rc => 
          <FormControlLabel
            
            control={<Radio 
              color="primary"             
            />}
            value={rc.join("+")}
            key={rc.join("+")}
            label={rc.join("+")}
            labelPlacement="start"
          />
       )}
       </RadioGroup>
      </FormControl>
      
    </DialogContent>
  </Dialog>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    allLocations: state.home.allLocations,
    allLocationGroups: state.home.allLocationGroups,
    allRoles: state.home.allRoles,
    workerRoleAvailabilities : state.home.workerRoleAvailabilities,
    workerLocationAvailabilities : state.home.workerLocationAvailabilities,
    plans : state.home.plans,
    workerAssignmentForm: state.home.workerAssignmentForm
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignmentForm));



// WEBPACK FOOTER //
// ./src/features/home/AssignmentForm.js